export default "__VITE_PUBLIC_ASSET__bea2eba0__"